
import { Route, Routes } from 'react-router-dom';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './Pages/Home/Home/Home';
import MyPortfolio from './Pages/Home/MyPortfolio';
import Footer from './Pages/Shared/Footer/Footer';
import Header from './Pages/Shared/Header/Header';
import { createContext, useState } from 'react';
import Blog from './Pages/Blog/Blog';
import Portfolio from './Pages/Portfolio/Portfolio';
import NotFound from './Pages/Shared/NotFound';
import Contact from './Pages/Home/Contact';

export const DarkModeContext = createContext("");

function App() {
  const [darkMode, setDarkMode] = useState(true);
  return (

    <div className={`${darkMode ? 'bg-gray-900' : 'bg-white'}`}>
      <DarkModeContext.Provider value={[darkMode, setDarkMode]}>
        <Header></Header>
        <div className='z-11 min-h-screen w-screen  border-8  border-red-900 fixed top-0 rounded '>

        </div>
        <div className='z-11 min-h-screen w-screen border-8  border-red-900 fixed top-0 rounded-2xl '></div>
        <Routes>
          <Route path='/' element={<Home></Home>}></Route>
          <Route path='/home' element={<Home></Home>}></Route>
          <Route path='/portfolio' element={<Portfolio />}></Route>
          <Route path='/about' element={<MyPortfolio></MyPortfolio>}></Route>
          <Route path='/contact' element={<div className='mt-16 py-12 lg:px-24 px-6'><Contact></Contact></div>}></Route>
          <Route path='/blog' element={<Blog />}></Route>
          <Route path='*' element={<NotFound />}></Route>
        </Routes>
        <ToastContainer />
        <Footer></Footer>

      </DarkModeContext.Provider>


    </div>
  );
}

export default App;
